import React, { useCallback, useEffect, useRef, useState } from "react";
import playIcon from "../../../assets/play.svg";
import pauseIcon from "../../../assets/pause.svg";
import useAudioPeaks from "./useAudioPeaks";
import VoiceWaveTrack from "./VoiceWaveTrack";
import "./VoiceRecorder.css";

const formatTime = (value) => {
  const safe = Math.max(0, Math.floor(value || 0));
  const min = Math.floor(safe / 60);
  const sec = safe % 60;
  return `${min}:${String(sec).padStart(2, "0")}`;
};

const VoiceWavePlayer = ({
  src,
  peaks = null,
  className = "",
  onDuration = () => {},
}) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [progress, setProgress] = useState(0);
  const { peaks: bars, decodedDuration } = useAudioPeaks(src, peaks);

  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) {
      audio.play();
      setIsPlaying(true);
    } else {
      audio.pause();
      setIsPlaying(false);
    }
  };

  return (
    <div className={`voice-wave-player ${className}`}>
      <button
        className="voice-recorder-btn play"
        onClick={togglePlay}
        title={isPlaying ? "Пауза" : "Слушать"}
        aria-label={isPlaying ? "Пауза" : "Слушать"}
      >
        <img src={isPlaying ? pauseIcon : playIcon} alt="" />
      </button>

      <VoiceWaveTrack
        audioRef={audioRef}
        src={src}
        progress={progress}
        onSeek={setProgress}
      />

      <span className="voice-wave-player-time">{formatTime(duration)}</span>

      <audio
        ref={audioRef}
        src={src}
        preload="metadata"
        onLoadedMetadata={(e) => {
          const value = e.target.duration || decodedDuration || 0;
          setDuration(value);
          onDuration(value);
        }}
        onTimeUpdate={(e) => {
          const audio = e.currentTarget;
          if (!audio.duration) return;
          setProgress(audio.currentTime / audio.duration);
        }}
        onEnded={() => {
          setIsPlaying(false);
          setProgress(0);
        }}
        onPause={() => setIsPlaying(false)}
        onPlay={() => setIsPlaying(true)}
        hidden
      />
    </div>
  );
};

export default VoiceWavePlayer;
